module.exports = __webpack_public_path__ + "static/media/badge_consultor.c6b10012.svg";